import PayCountries from '../../common/constants/payCountries';
import getCountryFromPostal from './getCountryFromPostal';

export default function isPostalCodeFromPayCountry(postalCode) {
  return PayCountries.includes(getCountryFromPostal(postalCode));
}
